import React from 'react';

export default function CertificationsHeader() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900">Certifications</h2>
      <p className="mt-1 text-gray-600">
        Add relevant certifications and professional credentials that demonstrate your expertise and
        qualifications. Include details like issuing organization and validity period.
      </p>
    </div>
  );
}